import React, { useEffect, useState } from "react";
import { DateRow } from "../Program/ProgramStyledComponents";
import { formatDateRangeShort } from "../../utils/commonFunction";
import { GetLearningMethodText, GetCampusText } from "../Program/ProgramHelperUtils";
import { tokens } from "../../public/tokens.js";
import { Heading5 } from "../common/GlobalElements/Typography.js";

export default function QualificationShortInfo({ qualification }) {
  const [courseType, setCourseType] = useState(null);

  useEffect(() => {
    if (qualification) {
      switch (qualification.type) {
        case "full":
        case "fulltimecontact":
        case "full_time_hybrid":
          setCourseType("Full Time, Hybrid");
          break;
        case "fulltimeonline":
        case "full_time_online":
        case "fulltime, online":
        case "online":
          setCourseType("Full Time, Online");
          break;
        case "fulltimecontact":
          setCourseType("Full Time, Contact");
          break;
        case "part":
        case "parttime":
        case "parttimeonline":
        case "part_time_online":
        case "cores":
        case "correspondence":
        case "part time":
          setCourseType("Part-Time, Online");
          break;
        case "selfplaced":
        case "selfpaced":
          setCourseType("Self-Paced");
          break;
        default:
          setCourseType(null);
          break;
      }
    }
  }, [qualification]);

  return (
    <>
      <Heading5 className="programme_titile" title={qualification?.course} style={{ borderBottom: `1px solid ${tokens.colors.ui.border}`, paddingBottom: "6px" }}>{qualification?.course}</Heading5>
       <div style={{ paddingBottom: "8px" }}>
        <DateRow as="span">
          <i className="fa-light fa-calendar-clock"></i>
          {qualification?.start && qualification?.end && formatDateRangeShort(qualification.start, qualification.end)}
          {qualification?.start && qualification?.end && qualification?.number && qualification?.year && " | "}
          {qualification?.number && qualification?.year && `Intake ${qualification.number}, ${qualification.year}`}
        </DateRow>
      </div>
      <div style={{ paddingBottom: "8px" }}>
        <DateRow as="span">
          <i className="fa-light fa-building-columns" />
          {qualification?.type && GetLearningMethodText(qualification.type)}
          {qualification?.type && qualification?.campus ? " - " : ""}
          {qualification?.campus && GetCampusText(qualification.campus)}
        </DateRow>
      </div>
    </>
  );
}
